import { ImgIcon } from '../ImgIcon';
import { Text } from '../Text';
import { StyledContainer } from './SectionHeading.styled';

interface ISectionHeadingProps extends React.HTMLAttributes<HTMLDivElement> {
	text: string;
	icon: string;
	gap?: number;
	iconSize?: number;
	fontSize?: number;
	textStyle?: React.CSSProperties;
	textOpacity?: number;
	iconOpacity?: number;
	fontWeight?: number;
	iconColor?: string;
	textColor?: string;
}

const SectionHeading: React.FC<ISectionHeadingProps> = ({
	text,
	icon,
	gap = 10,
	iconSize = 20,
	fontSize = 16,
	textStyle,
	textOpacity = 0.75,
	iconOpacity = 0.75,
	fontWeight = 400,
	iconColor = '#ffffff',
	textColor = '#ffffff',
	...props
}: ISectionHeadingProps) => {
	return (
		<StyledContainer
			$gap={gap}
			$iconSize={iconSize}
			$fontSize={fontSize}
			$textOpacity={textOpacity}
			$iconOpacity={iconOpacity}
			$fontWeight={fontWeight}
			$textColor={textColor}
			{...props}
		>
			<ImgIcon
				icon={icon}
				color={iconColor}
				width={iconSize}
				height={iconSize}
			/>
			<Text style={textStyle}>{text}</Text>
		</StyledContainer>
	);
};

export { SectionHeading };
